/* eslint-disable no-console */
import {
  createView,
  observableValue,
  useSharableState,
  view,
} from '@esui/core';
import { html } from 'lit';
import { DemoPage, Section } from '../@demo/utils.js';
import { Checkbox } from '../checkbox/index.js';
import { Radio } from '../radio/index.js';
import { Switch } from '../switch/index.js';
import { range } from '../util/range.js';
import { Formfield } from './index.js';

export const [FormfieldDemo] = view('formfield-demo', {
  template() {
    const [radioOne, radioTwo, radioThree] = range(3).map(() =>
      useSharableState(false)
    );
    const radioGroup = [radioOne, radioTwo, radioThree];
    console.log(radioGroup.map(v => v.value));

    const switchSelected = useSharableState(true);

    return DemoPage(
      Section(
        '',
        Formfield(Checkbox(observableValue<boolean>(false))).label(
          'This is a checkbox.'
        )
      ),

      Section(
        'Align End',
        Formfield(Checkbox(observableValue<boolean>(false)))
          .label('This is a checkbox.')
          .alignEnd()
      ),

      Section(
        'Native Element',
        Formfield(createView(html`<input type="date" />`))
          .label('Enter a date.')
          .alignEnd()
      ),

      Section(
        'Switch',
        Formfield(Switch(switchSelected)).label('This is a switch')
      ),

      Section(
        'Radio Buttons',
        Formfield(Radio(radioOne, radioGroup).id('one').name('a')).label(
          'This radio one'
        ),
        Formfield(Radio(radioTwo, radioGroup).id('two').name('a')).label(
          'This radio two'
        ),
        Formfield(Radio(radioThree, radioGroup).id('three').name('a')).label(
          'This radio three'
        )
      )
    );
  },
});
